<template>
  <div
    ref="preview"
    :class="[
      'image-preview',
      { 'image-preview--no-background-color': noBackgroundColor },
      { 'image-preview--click-disabled': displayOnly }
    ]"
    :style="`backgroundImage: url('${tempImageUrl || imageUrl}')`"
  >
    <input
      v-if="!displayOnly"
      ref="fileInput"
      type="file"
      class="image-preview__input"
      @change="previewFile($event)"
    >

    <div
      v-if="hasImage() && canBeDeleted"
      class="image-preview__delete"
      @click="removeImage"
    >
      <i class="el-icon-close" />
    </div>

    <p
      v-if="!hasImage()"
      class="image-preview__placeholder"
    >
      {{ placeholder || 'Image' }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ImagePreview',

  props: {
    placeholder: String,
    imageUrl: String,
    noBackgroundColor: Boolean,
    canBeDeleted: {
      default: false,
      type: Boolean
    },
    displayOnly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    image: {},
    tempImageUrl: null
  }),

  watch: {
    /**
     */
    imageUrl () {
      this.tempImageUrl = null
    }
  },

  methods: {
    /**
     * @param {Event} [event]
     */
    previewFile (event) {
      const file = this.getEventFile(event)
      const reader = new FileReader()

      if (file) {
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          this.tempImageUrl = reader.result
        }

        this.image.file = file

        this.$emit('image-change', {
          image: this.image
        })
      } else {
        this.tempImageUrl = ''
      }

      this.$refs.fileInput.value = ''
    },

    /**
     * @param   {Event} event
     *
     * @returns {File}
     */
    getEventFile (event) {
      return event.currentTarget.files[0]
    },

    /**
     * @returns {boolean}
     */
    hasImage () {
      return this.tempImageUrl || this.imageUrl
    },

    /**
     * Sends an event to the parent to that an action can be taken to delete the image.
     */
    removeImage () {
      this.$emit('image-delete')
    }
  }
}
</script>

<style lang="scss" scoped>
$image-preview-padding: $spacer-unit-small / 2 $spacer-unit-small $spacer-unit $spacer-unit;

.image-preview {
  @include size(100%);

  position: relative;
  background-color: $purple-light;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border-radius: $border-radius-default;
  cursor: pointer;

  &.image-preview--click-disabled {
    cursor: default;
  }

  .image-preview__delete {
    position: absolute;
    top: 0;
    right: 0;
    padding: $image-preview-padding;
    color: $red;
    font-weight: $font-weight-bold;
    font-size: $font-size-large;
    cursor: pointer;
    opacity: 0;
  }

  &:hover {
    background-color: $purple-light-hover;
    cursor: pointer;

    .image-preview__delete {
      opacity: 1;
    }
  }
}

.image-preview--no-background-color {
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
}

.image-preview__input {
  @include size(100%);

  min-height: inherit;
  max-height: inherit;
  padding: $spacer-unit;
  opacity: 0;
}

.image-preview__placeholder {
  @include absolute-center;
  @include font-size($font-size-small);

  margin: 0;
  color: $purple;
  font-weight: $font-weight-medium;
  text-align: center;
  pointer-events: none;
}
</style>
